module.exports = __webpack_public_path__ + "img/financeiro.851589c4.svg";